<template>
	<div
		:id="getTabpanelId(currentTabHash)"
		class="w-full hidden sm:block mt-2.5"
		role="tabpanel"
		tabindex="0"
		:aria-labelledby="getTabId(currentTabHash)"
	>
		<div class="tab-content tab-space">
			<div
				:class="[
					'cms-element-product-description-reviews__description max-w-full overflow-hidden'
				]"
			>
				<div
					v-if="currentTabHash === ProductDetailsTabs.DESCRIPTION"
					class="mt-2 prose prose-sm max-w-none"
					v-html="description"
				></div>
				<div
					v-else-if="currentTabHash === ProductDetailsTabs.SPECIFICATION"
					class="mt-2 flex flex-col"
				>
					<div
						v-for="parametric in currentTabSpecification"
						:key="parametric.Id"
						class="flex justify-between flex-1 py-4 border-b border-gray-dark"
					>
						<span>{{ parametric.Name }}</span>
						<span>{{ parametric.Value }}</span>
					</div>
				</div>
				<div
					v-else-if="currentTabHash === ProductDetailsTabs.SIZE_GUIDE"
					class="mt-2"
				>
					<NuxtImg
						v-if="sizeGuideImage"
						:src="sizeGuideImage.filename"
						:alt="sizeGuideImage.alt || 'Size guide'"
						provider="storyblok"
						class="w-full max-w-96"
					/>
				</div>
				<div
					v-else-if="currentTabHash === ProductDetailsTabs.WASHING_INSTRUCTIONS"
					class="mt-2"
				>
					<NuxtImg
						v-if="washingInstructionImage"
						:src="washingInstructionImage.filename"
						:alt="washingInstructionImage.alt || 'Washing instructions'"
						provider="storyblok"
						class="w-full max-w-80"
					/>
				</div>
				<div
					v-else-if="currentTabHash === ProductDetailsTabs.REVIEWS"
					class="mt-2"
				>
					<!-- sm+ only: on mobile the accordion renders the list; a hidden copy -->
					<!-- here would come first in the DOM with the same #lipscore-review-list. -->
					<ProductLipscoreProductReviews v-if="isSmUp" />
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useMediaQuery } from "@vueuse/core";
import { getTabId, getTabpanelId } from "~/utils/product/productTabIds";
import type { VariantParametric } from "@nwt/norce-pwa/dist/runtime/types/api/product/product";
import type { Image } from "~/types/storyblok/storyblok";

interface Props {
	description: string | undefined;
	currentTabHash: string;
	currentTabSpecification: VariantParametric[] | undefined;
	sizeGuideImage?: Image;
	washingInstructionImage?: Image;
}

defineProps<Props>();

// Same breakpoint as the `hidden sm:block` wrapper in ProductDetails.
const isSmUp = useMediaQuery("(min-width: 640px)");
</script>
